import { render, staticRenderFns } from "./HorizontalCarousel.vue?vue&type=template&id=35a631ac&"
import script from "./HorizontalCarousel.vue?vue&type=script&lang=js&"
export * from "./HorizontalCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a631ac')) {
      api.createRecord('35a631ac', component.options)
    } else {
      api.reload('35a631ac', component.options)
    }
    module.hot.accept("./HorizontalCarousel.vue?vue&type=template&id=35a631ac&", function () {
      api.rerender('35a631ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/lib/vue/components/modules/HorizontalCarousel.vue"
export default component.exports